import React from "react";
import NewClickToFlyContent from "../components/click-to-fly/new-click-to-fly-content";

const NewClickToFly = () => {
  return <NewClickToFlyContent />;
};

export default NewClickToFly;

